import React, { useEffect, useState } from 'react';
import { Container, Row, Stack } from 'react-bootstrap';
import { asve } from '../orve';
import {
  getAssessmentContentPercentile,
  getAssessmentContentCutoffs,
  getAssessmentText,
  getCandidateHonestyHumilityText,
} from '../report-util';
import { useAuth } from '../../../../providers/auth-provider';
import { REPORT_TYPE } from '../../../../utils/constants';

function CoachingPersonalityPage1({ candidate, reportType = REPORT_TYPE.development }) {
  const { isSelect } = useAuth();
  const [assessmentText, setAssessmentText] = useState({});

  useEffect(() => {
    if (candidate) {
      setAssessmentText(asve(candidate));
    }
  }, [candidate]);

  return (
    <Container className="bg-white mt-2 mb-3 candidate-profile-assessments">
      {candidate && (
        <>
          <Container className="candidate-profile-assessment-content">
            <Row className="justify-content-left w-50">
              <h3 className="pt-4 pb-1">PERSONALITY</h3>
              <Stack direction="horizontal" gap={4}>
                {getAssessmentContentPercentile('Overall Personality', candidate.percentiles.personality, reportType)}
              </Stack>
            </Row>
            <Row className="w-100 pb-2">{getAssessmentText(assessmentText.personality)}</Row>
            <Row className="w-100 mx-auto justify-content-center pt-3">
              <Stack direction="horizontal" className="subscore-chart">
                <div className="w-25">
                  {getAssessmentContentCutoffs(
                    getCandidateHonestyHumilityText(isSelect()),
                    candidate.personality.scores.honestyHumility.overall,
                    undefined,
                    reportType
                  )}
                </div>
                <div className="w-75">{getAssessmentText(assessmentText.honestyHumility)}</div>
              </Stack>
              <Row className="w-100 mx-auto justify-content-center ms-5">
                <Stack direction="horizontal" className="subscore-chart">
                  <div className="w-25">
                    {getAssessmentContentCutoffs(
                      'Sincerity',
                      candidate.personality.scores.honestyHumility.sincerity,
                      undefined,
                      reportType
                    )}
                  </div>
                  <div className="w-75">{getAssessmentText(assessmentText.sincerity)}</div>
                </Stack>
                <Stack direction="horizontal" className="subscore-chart">
                  <div className="w-25">
                    {getAssessmentContentCutoffs(
                      'Fairness',
                      candidate.personality.scores.honestyHumility.fairness,
                      undefined,
                      reportType
                    )}
                  </div>
                  <div className="w-75">{getAssessmentText(assessmentText.fairness)}</div>
                </Stack>
              </Row>
              <Stack direction="horizontal" className="subscore-chart">
                <div className="w-25">
                  {getAssessmentContentCutoffs(
                    'Emotionality',
                    candidate.personality.scores.emotionalControl.overall,
                    undefined,
                    reportType
                  )}
                </div>
                <div className="w-75">{getAssessmentText(assessmentText.emotionalControl)}</div>
              </Stack>
              <Row className="w-100 mx-auto justify-content-center ms-5">
                <Stack direction="horizontal" className="subscore-chart">
                  <div className="w-25">
                    {getAssessmentContentCutoffs(
                      'Courageous',
                      candidate.personality.scores.emotionalControl.courageous,
                      undefined,
                      reportType
                    )}
                  </div>
                  <div className="w-75">{getAssessmentText(assessmentText.courageous)}</div>
                </Stack>
                <Stack direction="horizontal" className="subscore-chart">
                  <div className="w-25">
                    {getAssessmentContentCutoffs(
                      'Collectedness',
                      candidate.personality.scores.emotionalControl.collectedness,
                      undefined,
                      reportType
                    )}
                  </div>
                  <div className="w-75">{getAssessmentText(assessmentText.collectedness)}</div>
                </Stack>
                <Stack direction="horizontal" className="subscore-chart">
                  <div className="w-25">
                    {getAssessmentContentCutoffs(
                      'Independence',
                      candidate.personality.scores.emotionalControl.independence,
                      undefined,
                      reportType
                    )}
                  </div>
                  <div className="w-75">{getAssessmentText(assessmentText.independence)}</div>
                </Stack>
              </Row>
            </Row>
          </Container>
        </>
      )}
    </Container>
  );
}

export default CoachingPersonalityPage1;
